/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxMinDto } from '../../models/backend-tax-min-dto';
import { BackendTaxMinRequestDto } from '../../models/backend-tax-min-request-dto';

export interface ProjectTaxesTaxMinCreate$Params {
  body: BackendTaxMinRequestDto;
}

export function projectTaxesTaxMinCreate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxMinCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxMinDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxMinCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxMinDto>;
    }),
  );
}

projectTaxesTaxMinCreate.PATH = '/api/project_taxes/tax_min/';
